import _ from 'lodash';
import { Firebase, withoutId, ifCallbackIsFunction, generateSafePassword, getCurrentTimestamp, accountId, organizationId, isProduction, omitDeleted, addKeysAsIds } from './../util';
import { OrganizationRef, TeamsRef } from './../util/refs';

import {
  BEGIN_EDITING_TEAM,
  SAVE_TEAM,
  SAVE_TEAM_SUCCESS,
  SAVE_TEAM_ERROR,
  END_EDITING_TEAM,

} from './types';

//PHIL TODO IMPLEMENT ALL THESE

export function beginEditingTeam(teamData){
  return {
    type: BEGIN_EDITING_TEAM,
    payload: teamData
  }
}

export function stopEditingTeam(){
  return {
    type: END_EDITING_TEAM
  }
}

export function createOrUpdateTeam(teamData){
  if(teamData._id){
    return updateTeam(teamData);
  }
  else{
    return createTeam(teamData);
  }
}

function logAndDispatchErrorForAction(action, err, dispatch){
  console.log('Error during', action, ':', err);
  dispatch({
    type: SAVE_TEAM_ERROR,
    payload: err.message
  });
}

export function createTeam(teamData){
  console.log('creating team!');

  return dispatch => {

    dispatch({
      type: SAVE_TEAM,
      payload: teamData,
    });

    let newTeam = {
      ...teamData,
      createdOn: getCurrentTimestamp(),
      lastUpdated: getCurrentTimestamp(),
    }

    //create team object in db
    TeamsRef().add(newTeam).then(teamRef => {

      const newTeamId = teamRef.id;
      console.log('team created with id: ', newTeamId);

      newTeam._id = newTeamId;

      dispatch({
        type: SAVE_TEAM_SUCCESS,
        payload: {
          team: newTeam,
          message: 'New team created & added to organization',
        }
      });

    }).catch(err => logAndDispatchErrorForAction('Create Team Object', err, dispatch));
  }
}

export function updateTeam(teamData){

  console.log('updating team!');

  const teamId = teamData._id;

  return dispatch => {

    dispatch({
      type: SAVE_TEAM,
      payload: teamData,
    });

    TeamsRef().doc(teamId).update({
      ...withoutId(teamData),
      lastUpdated: getCurrentTimestamp(),
    }).then(() => {

      console.log('team update successful! new object: ', teamData);

      dispatch({
        type: SAVE_TEAM_SUCCESS,
        payload: {
          team: teamData,
          message: 'Team updated.',
        }
      });
    }).catch(err => logAndDispatchErrorForAction('Update team object', err, dispatch));

  }
}

export function deleteTeam(teamData, callback){
  console.log('deleting team!');

  const teamId = teamData._id;

  return dispatch => {

    dispatch({
      type: SAVE_TEAM,
      payload: teamData,
    });

    TeamsRef().doc(teamId).delete().then(() => {

      console.log('team delete successful!');

      dispatch({
        type: END_EDITING_TEAM
      });

      ifCallbackIsFunction(callback, teamData);

      // dispatch({
      //   type: SAVE_TEAM_SUCCESS,
      //   payload: {
      //     team: {
      //       ...teamData,
      //       _deleted: true,
      //     },
      //     success: 'Team deleted.',
      //   }
      // });
    }).catch(err => logAndDispatchErrorForAction('Delete team object', err, dispatch));

  }
}



// WEBPACK FOOTER //
// ./src/actions/teams.js